import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Pencil, Printer, Palette, Baby, Infinity } from 'lucide-react';
export function BenefitsStrip() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const benefits = [{
    icon: Pencil,
    title: 'Español + English',
    subtitle: 'en cada actividad'
  }, {
    icon: Printer,
    title: 'Imprime desde casa',
    subtitle: 'en minutos'
  }, {
    icon: Palette,
    title: '+100 páginas',
    subtitle: 'de actividades'
  }, {
    icon: Baby,
    title: 'Diseñado para',
    subtitle: 'edades 2 a 12 años'
  }, {
    icon: Infinity,
    title: 'Imprime las veces',
    subtitle: 'que quieras'
  }];
  return <section ref={ref} className="w-full bg-orange-50 py-16 md:py-20" data-id="element-14">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-15">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-16">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.1 * index,
          duration: 0.5
        }} className="bg-white p-6 rounded-2xl shadow-lg text-center" data-id="element-17">
              <div className="flex justify-center mb-4" data-id="element-18">
                <div className="bg-orange-100 p-4 rounded-full" data-id="element-19">
                  <benefit.icon className="w-8 h-8 text-orange-600" data-id="element-20" />
                </div>
              </div>
              <h3 className="font-fredoka text-lg font-bold text-gray-900 mb-1" data-id="element-21">
                {benefit.title}
              </h3>
              <p className="font-nunito text-sm text-gray-600" data-id="element-22">
                {benefit.subtitle}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}